import StatsTablesComponent from './StatsTablesComponent';
import SpellBlockComponent from './SpellBlockComponent';
import { useTranslation } from 'react-i18next';
import SpeedComponent from './SpeedComponent';
import { CreatureStats, SpeedObject, Spell, TitleDescriptionObject } from '../../Types/TableTypes';
import TitleDescriptionListComponent from './TitleDescriptionListComponent';
import OtherStatsComponent from './OtherStatsComponent';

interface TableRowBottomComponentProps{
    creatureStats: CreatureStats,
    // index: number,
    updateCreatureStats: (creatureStats: CreatureStats) => void,
    editMode: boolean,
    expanded: boolean,
}

const TableRowBottomComponent = (props: TableRowBottomComponentProps)=> {
    const { t } = useTranslation();

    // console.log("render statblock");
    return(
         <tr className={props.expanded ? "" : "hidden"}>
            <td colSpan={9}
                // width={"100%"} 
                style={{  
                    boxShadow: "0px 8px 5px lightgray inset,0px -8px 5px lightgray inset",
                    padding: "1rem 3rem",
                    // backgroundColor: "#f5f3ee"
                }}
            > 
                <div className="statblock fs-5 pb-2" > 
                    {props.editMode && <div className='w-100 p-3 d-flex justify-content-between'>
                        {/* <label className="form-check-label">has spellcasting <input type="checkbox" className="form-check-input" autoComplete="off" checked={props.creatureStats.hasSpellCasting} onChange={e=>{props.creatureStats.hasSpellCasting=e.target.checked;props.updateCreatureStats(props.creatureStats);}}/></label> */}
                        <label className="form-check-label">{t("isplayer")}&nbsp;<input type="checkbox" className="form-check-input" autoComplete="off" checked={props.creatureStats.isPlayer} onChange={e=>{props.creatureStats.isPlayer=e.target.checked;props.updateCreatureStats(props.creatureStats);}}/></label>
                        <span className="d-flex">
                            <span  className="">{t("proficiencybonus")}&nbsp;</span>
                            <input
                                type='number'
                                className='form-control'
                                style={{width: "70px"}}
                                value={props.creatureStats.proficiencyBonus}
                                onChange={e => {
                                    props.creatureStats.proficiencyBonus = (parseInt(e.target.value));
                                    props.updateCreatureStats(props.creatureStats);
                                }}
                            ></input>
                        </span>
                        <span className="d-flex">
                            <span  className="">{t("initiativebonus")}&nbsp;</span>
                            <input
                                type='number'
                                className='form-control'
                                style={{width: "70px"}}
                                value={props.creatureStats.initiativeBonus}
                                onChange={e => {
                                    props.creatureStats.initiativeBonus = (parseInt(e.target.value));
                                    props.updateCreatureStats(props.creatureStats);
                                }}
                            ></input>
                        </span>
                        <span className="d-flex">
                            <span  className="">{t("passiveperception")}&nbsp;</span>
                            <input
                                type='number'
                                className='form-control'
                                style={{width: "70px"}}
                                value={props.creatureStats.otherStats.senses.passivePerception}
                                onChange={e => {
                                    props.creatureStats.otherStats.senses.passivePerception = (parseInt(e.target.value));
                                    props.updateCreatureStats(props.creatureStats);
                                }}
                            ></input>
                        </span>
                    </div>}
                    {props.editMode && <div className='w-100 p-3 stat-row-horiz'>
                        <input
                            value={props.creatureStats.type}
                            placeholder={t("placeholder-type")}
                            className='form-control'
                            type="text"
                            style={{width: "20%"}}
                            onChange={e => {
                                props.creatureStats.type = ((e.target.value));
                                props.updateCreatureStats(props.creatureStats);
                            }}
                        ></input>
                        <input
                            value={props.creatureStats.size}
                            type="text"
                            className='form-control'
                            style={{width: "20%"}}
                            placeholder={t("placeholder-size")}
                            onChange={e => {
                                props.creatureStats.size = ((e.target.value));
                                props.updateCreatureStats(props.creatureStats);
                            }}
                        ></input>
                        <input
                            placeholder={t("placeholder-alignment")}
                            value={props.creatureStats.alignment}
                            type="text"
                            className='form-control'
                            style={{width: "20%"}}
                            onChange={e => {
                                props.creatureStats.alignment = ((e.target.value));
                                props.updateCreatureStats(props.creatureStats);
                            }}
                        ></input>
                        
                    </div>}
                    {!props.editMode && <div className='w-100 p-3 stat-row-horiz d-flex flex-wrap justify-content-between'>
                        <div className='text-secondary fst-italic'>
                            <span>{props.creatureStats.type}</span>&nbsp;<span>{props.creatureStats.size}</span>&nbsp;<span>{props.creatureStats.alignment}</span>
                        </div>
                        <div>
                            <span className='ms-2'>{"initiative: "+(props.creatureStats.initiativeBonus > 0 ? "+" : "") +props.creatureStats.initiativeBonus }</span>
                            <span className='ms-2'>{"passive perception: "+props.creatureStats.otherStats.senses.passivePerception}</span>
                        </div>
                    </div>
                    }
                    <div>
                        <SpeedComponent editMode={props.editMode} speed = {props.creatureStats.speed} updateSpeed = {(speed: SpeedObject) => {
                            props.creatureStats.speed = speed;
                            props.updateCreatureStats(props.creatureStats);
                        }}/>
                        <StatsTablesComponent 
                            stats={props.creatureStats.stats} 
                            editMode={props.editMode}
                            //speed={props.creatureStats.speed}
                            updateValues={(
                            stats: {
                                str: number,
                                dex: number,
                                con: number,
                                int: number,
                                wis: number,
                                cha: number,
                                strSave: number,
                                dexSave: number,
                                conSave: number,
                                intSave: number,
                                wisSave: number,
                                chaSave: number,
                            }) =>{
                                props.creatureStats.stats = stats;
                                props.updateCreatureStats(props.creatureStats)
                            }}  
                        />
                        
                    </div>
                    <OtherStatsComponent
                        otherStats={props.creatureStats.otherStats}
                        editMode={props.editMode}
                        updateStats={(otherStats) => {
                            props.creatureStats.otherStats = otherStats;
                            props.updateCreatureStats(props.creatureStats);
                        }}
                    />
                    {((props.creatureStats.traits != null && props.creatureStats.traits.length > 0) || props.editMode) && <TitleDescriptionListComponent 
                        sectionTitle={t("section-traits")}
                        column={true}
                        list={props.creatureStats.traits} 
                        editMode={props.editMode}
                        subtext={props.creatureStats.traitsText}
                        updateValues={(subtext: string, values: TitleDescriptionObject[]) =>{
                            props.creatureStats.traitsText = subtext;
                            props.creatureStats.traits = values;
                            props.updateCreatureStats(props.creatureStats)
                        }}/>
                    }
                    {((props.creatureStats.equipment != null && props.creatureStats.equipment.length > 0) || props.editMode) && <TitleDescriptionListComponent 
                        sectionTitle={t("section-equipment")}
                        column={false}
                        list={props.creatureStats.equipment} 
                        subtext={props.creatureStats.equipmentText}
                        editMode={props.editMode}
                        updateValues={(subtext: string, values: TitleDescriptionObject[]) =>{
                            props.creatureStats.equipment = values;
                            props.creatureStats.equipmentText = subtext;
                            props.updateCreatureStats(props.creatureStats)
                        }}/>
                    }
                {/* </div>
                <div className='col-lg-6 col-12 pb-2'>    */}
                    {((props.creatureStats.actions != null && props.creatureStats.actions.length > 0) || props.editMode) && <TitleDescriptionListComponent 
                        sectionTitle={t("section-actions")}
                        column={true}
                        list={props.creatureStats.actions} 
                        editMode={props.editMode}
                        subtext={props.creatureStats.actionsText}
                        updateValues={(subtext: string, values: TitleDescriptionObject[]) =>{
                            props.creatureStats.actionsText=subtext;
                            props.creatureStats.actions = values;
                            props.updateCreatureStats(props.creatureStats)
                        }}/>
                    }
                    {((props.creatureStats.bonusActions != null && props.creatureStats.bonusActions.length > 0) || props.editMode) && <TitleDescriptionListComponent 
                        sectionTitle={t("section-bonusactions")}
                        column={true}
                        list={props.creatureStats.bonusActions} 
                        editMode={props.editMode}
                        subtext={props.creatureStats.bonusActionsText}
                        updateValues={(subtext: string, values: TitleDescriptionObject[]) =>{
                            props.creatureStats.bonusActionsText=subtext;
                            props.creatureStats.bonusActions = values;
                            props.updateCreatureStats(props.creatureStats)
                        }}/>
                    }
                    {((props.creatureStats.legendaryActions != null && props.creatureStats.legendaryActions.length > 0) || props.editMode) && <TitleDescriptionListComponent 
                        sectionTitle={t("section-legendaryactions")}
                        column={true}
                        list={props.creatureStats.legendaryActions} 
                        editMode={props.editMode}
                        subtext={props.creatureStats.legendaryActionsText}
                        updateValues={(subtext: string, legendaryActions: TitleDescriptionObject[]) =>{
                            props.creatureStats.legendaryActionsText = subtext;
                            props.creatureStats.legendaryActions = legendaryActions;
                            props.updateCreatureStats(props.creatureStats)
                        }}/>
                    }
                    {((props.creatureStats.reactions != null && props.creatureStats.reactions.length > 0) || props.editMode) && <TitleDescriptionListComponent 
                        sectionTitle={t("section-reaction")}
                        column={false}
                        list={props.creatureStats.reactions} 
                        subtext={props.creatureStats.reactionsText}
                        editMode={props.editMode}
                        updateValues={(subtext: string, values: TitleDescriptionObject[]) =>{
                            props.creatureStats.reactions = values;
                            props.creatureStats.reactionsText = subtext;
                            props.updateCreatureStats(props.creatureStats)
                        }}/>
                    }
                    <span>{((props.creatureStats.spellcasting.spellGroups != null && props.creatureStats.spellcasting.spellGroups.length > 0) || props.editMode)}</span>
                    {((props.creatureStats.spellcasting.spellGroups != null && props.creatureStats.spellcasting.spellGroups.length > 0) || props.editMode) && 
                        
                        <SpellBlockComponent spellcastingStats={props.creatureStats.spellcasting} updateSpellcastingStats={updateSpellcastingStats} editMode={props.editMode}/>
                    }
                </div>
            </td>
        </tr> 
    );

    function updateSpellcastingStats(spellcastingStats:{
            spellCharacteristic: string,
            spellSave: number,
            spellAttackMod: number,
            spellGroups: {
                label: string,
                // level: number,
                hasSlotsGroup: boolean,
                hasSlotsEach: boolean,
                remainingSlots: number,
                maxSlots: number,
                list: Spell[]
            }[]
        }){
            props.creatureStats.spellcasting = spellcastingStats;
            props.updateCreatureStats(props.creatureStats);
        }
}

export default TableRowBottomComponent;